import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'treatment-detail',
  methods: {
    goBack: function () {
      this.$router.go(-1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/treatment-detail.js